export const allDrugs = [
  {
    id: "ozempic",
    name: "Ozempic",
    generic: "semaglutide",
    class: "GLP-1",
    doses: ["0.25 mg", "0.5 mg", "1 mg", "2 mg"]
  },
  {
    id: "trulicity",
    name: "Trulicity",
    generic: "dulaglutide",
    class: "GLP-1",
    doses: ["0.75 mg", "1.5 mg", "3 mg", "4.5 mg"]
  },
  {
    id: "mounjaro",
    name: "Mounjaro",
    generic: "tirzepatide",
    class: "GLP-1",
    doses: ["2.5 mg", "5 mg", "7.5 mg", "10 mg", "12.5 mg", "15 mg"]
  },
  {
    id: "jardiance",
    name: "Jardiance",
    generic: "empagliflozin",
    class: "SGLT2",
    doses: ["10 mg", "25 mg"]
  },
  {
    id: "farxiga",
    name: "Farxiga",
    generic: "dapagliflozin",
    class: "SGLT2",
    doses: ["5 mg", "10 mg"]
  },
  {
    id: "wegovy",
    name: "Wegovy",
    generic: "semaglutide",
    class: "GLP-1",
    doses: ["0.25 mg", "0.5 mg", "1 mg", "1.7 mg", "2.4 mg"]
  },
  {
    id: "zepbound",
    name: "Zepbound",
    generic: "tirzepatide",
    class: "GLP-1",
    doses: ["2.5 mg", "5 mg", "7.5 mg", "10 mg", "12.5 mg", "15 mg"]
  }
  // Add more drugs as needed!
];